<script setup lang="ts">
import type { ListboxItemEmits, ListboxItemProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { injectListboxRootContext, ListboxItem, useForwardProps } from 'reka-ui'
import { computed } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<ListboxItemProps & { class?: HTMLAttributes['class'] }>()
const emits = defineEmits<ListboxItemEmits>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardProps(delegatedProps)

const rootContext = injectListboxRootContext()
const isDisabled = computed(() => rootContext.disabled.value || props.disabled)

function onSelect(event: ListboxItemEmits['select'][0]) {
  if (isDisabled.value) {
    event.preventDefault()
    return
  }
  emits('select', event)
}
</script>

<template>
  <ListboxItem
    v-bind="forwarded"
    :aria-disabled="isDisabled ? 'true' : undefined"
    :class="
      cn(
        'relative flex cursor-pointer gap-2 select-none items-center rounded-md px-3 py-1.5 text-sm text-gray-700 outline-hidden data-highlighted:bg-gray-100 data-highlighted:text-gray-900 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:size-5 [&_svg]:shrink-0 [&_svg]:text-gray-400 [&[data-highlighted]_svg]:text-gray-900',
        props.class,
      )
    "
    @select="onSelect"
  >
    <slot />
  </ListboxItem>
</template>
